import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthState } from "./types";

export const DEMO_EMAIL = "demo@xitester.dev";
export const DEMO_PASSWORD = "demo1234";

interface AuthStore extends AuthState {
	login: (email: string, password: string) => { ok: true } | { ok: false; error: string };
	logout: () => void;
	isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthStore>()(
	persist(
		(set, get) => ({
			email: null,
			token: null,
			login: (email, password) => {
				if (email.trim().toLowerCase() !== DEMO_EMAIL || password !== DEMO_PASSWORD) {
					return { ok: false, error: "Invalid credentials. Try demo@xitester.dev / demo1234." };
				}
				const token = `sut-${crypto.randomUUID()}`;
				set({ email: email.trim().toLowerCase(), token });
				return { ok: true };
			},
			logout: () => set({ email: null, token: null }),
			isAuthenticated: () => Boolean(get().token),
		}),
		{ name: "xitester-sut-auth" }
	)
);
